import DialogTitle from '@apps-common/ui-components/DialogTitle.jsx';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkIcon from '@mui/icons-material/Link';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {PLAYER_URL} from '../../../config.js';
import {theme} from '../../../styles.js';
import ShareButton from './share-button.jsx';
import XIcon from './x-logo.jsx';

const baseText = 'Check out this story of change I made with imagery from';

class ShareDialog extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    story: PropTypes.object.isRequired,
    trackEvent: PropTypes.func.isRequired,
  };

  state = {
    copyLabelShown: false,
  };

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  onEmailClick = () => this.props.trackEvent('Email button clicked');

  onLinkClick = () => {
    this.textField.focus();
    this.textField.select();
    document.execCommand('copy');
    this.props.trackEvent('Copy link button clicked');

    clearTimeout(this.timeout);
    this.setState({copyLabelShown: true}, () => {
      this.timeout = setTimeout(this.hideCopyLabel, 3000);
    });
  };

  hideCopyLabel = () => this.setState({copyLabelShown: false});

  renderEmailButton(url) {
    const params = new URLSearchParams({
      subject: this.props.story.title,
      body: `${baseText} Planet: ${url}`,
    });

    return (
      <ShareButton
        icon={<EmailIcon />}
        color={theme.palette.grey[500]}
        href={`mailto:?${params.toString()}`}
        onClick={this.onEmailClick}
        data-cy="Email-share-button"
      />
    );
  }

  renderSocialMediaButton(props) {
    return (
      <ShareButton
        {...props}
        data-cy={`${props.name}-share-button`}
        trackEvent={this.props.trackEvent}
      />
    );
  }

  render() {
    const url = `${PLAYER_URL}/${this.props.story.id}`;
    return (
      <Dialog
        fullWidth
        maxWidth="xs"
        open={this.props.open}
        onClose={this.props.onClose}
      >
        <DialogTitle
          data-cy="popup-title"
          title="Share story"
          onClose={this.props.onClose}
        />
        <DialogContent>
          <Grid container>
            {this.renderSocialMediaButton({
              name: 'Twitter',
              icon: <XIcon />,
              color: '#000000',
              url: 'https://twitter.com/intent/tweet',
              query: {
                url,
                text: `${baseText} @planet`,
                hashtags: 'PlanetStories',
              },
            })}
            {this.renderSocialMediaButton({
              name: 'Facebook',
              icon: <FacebookIcon />,
              color: '#3b5998',
              url: 'https://www.facebook.com/sharer.php',
              query: {u: url},
            })}
            {this.renderSocialMediaButton({
              name: 'LinkedIn',
              icon: <LinkedInIcon />,
              color: '#0077b5',
              url: 'https://www.linkedin.com/shareArticle',
              query: {
                url,
                mini: true,
                title: this.props.story.title,
                summary: `${baseText} @Planet`,
              },
            })}
            {this.renderEmailButton(url)}
            <ShareButton
              data-cy="Link-share-button"
              icon={<LinkIcon />}
              color={theme.palette.grey[200]}
              iconColor={theme.palette.grey[800]}
              onClick={this.onLinkClick}
            />
          </Grid>
          <br />
          <TextField
            fullWidth
            readOnly
            label={
              this.state.copyLabelShown ? 'Copied to clipboard!' : 'Story URL'
            }
            value={url}
            inputRef={node => {
              this.textField = node;
            }}
            data-cy="story-url"
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.props.onClose}
            data-cy="share-done-button"
            color="primary"
            variant="contained"
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ShareDialog;
